import apiPaths from '../../api-paths.js';

export default {
    index(invoiceId) {
        return axios.get(`${ apiPaths.BOOKKEEPING }/invoices/${invoiceId}/sent-emails`);
    },
    store(invoiceId, data) {
        return axios.post(`${ apiPaths.BOOKKEEPING }/invoices/${invoiceId}/sent-emails`, data);
    },
};
